import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-enlace-back',
  templateUrl: './enlace-back.component.html',
  styleUrls: ['./enlace-back.component.scss']
})
export class EnlaceBackComponent {
  @Input() enlace_texto: string = "Volver";
}
